import { RouterType, serverRouteHandlers } from '@online-webinar/router';

import genericCss from '../generic.css?inline';
import whitelabelCss from '../whitelabel.css?inline';

export const updateRoute = (router: RouterType) => {
    if (!import.meta.env.SSR) {
        return;
    }

    serverRouteHandlers.site = async () => {
        return new Response(process.env.VITE_IS_WHITELABEL === 'true' ? whitelabelCss : genericCss, { headers: { 'Content-Type': 'text/css' } });
    };
};
